import { BoelsPointOfService, SpecialismList } from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const setActiveStore = createAction(
  '[Storefinder] Set active Store',
  props<{ store: BoelsPointOfService | undefined }>(),
);

export const setActiveRegion = createAction(
  '[Storefinder] Set active Region',
  props<{ region: string | null }>(),
);

export const setSpecialismList = createAction(
  '[Storefinder] Set Specialism List',
  props<{ lang: string; specialismList: SpecialismList | undefined }>(),
);
